import React from 'react';
import { Box, styled } from '@mui/material';
import { BookingState } from 'common/modules/bookings';
import { getBookingStateLabel } from '../utils';
import { useTranslation } from 'services/localization';

export interface Props {
	state: BookingState;
}
const BookingStateBadge = (props: Props) => {
	const { state } = props;
	const { t } = useTranslation();

	switch (state) {
		case 'PENDING':
			return <OpenBadge>{getBookingStateLabel(state, t)}</OpenBadge>;
		case 'ACTIVE':
			return <ActiveBadge>{getBookingStateLabel(state, t)}</ActiveBadge>;
		case 'EXPIRED':
			return <ExpiredBadge>{getBookingStateLabel(state, t)}</ExpiredBadge>;
		case 'UPCOMING':
			return <UpcomingBadge>{getBookingStateLabel(state, t)}</UpcomingBadge>;
		case 'COMPLETED':
			return <CompletedBadge>{getBookingStateLabel(state, t)}</CompletedBadge>;
		case 'CANCELLED':
			return <CancelledBadge>{getBookingStateLabel(state, t)}</CancelledBadge>;
	}
};

const BaseBadge = styled(Box)(({ theme }) => ({
	padding: theme.spacing(2),
	borderWidth: '1px',
	borderStyle: 'solid',
	borderRadius: '4px',
	fontSize: '1.2rem',
	fontWeight: 500,
	height: '36px',
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	minWidth: '90px',
}));

const OpenBadge = styled(BaseBadge)(({ theme }) => ({
	borderColor: theme.palette.warning.dark,
	color: theme.palette.warning.dark,
}));

const ActiveBadge = styled(BaseBadge)(({ theme }) => ({
	borderColor: theme.palette.success.light,
	backgroundColor: theme.palette.success.light,
	color: theme.palette.success.dark,
}));

const ExpiredBadge = styled(BaseBadge)(({ theme }) => ({
	borderColor: theme.palette.error.light,
	backgroundColor: theme.palette.error.light,
	color: theme.palette.error.main,
}));

const UpcomingBadge = styled(BaseBadge)(({ theme }) => ({
	borderColor: theme.palette.warning.light,
	backgroundColor: theme.palette.warning.light,
	color: theme.palette.warning.dark,
}));

const CompletedBadge = styled(BaseBadge)(({ theme }) => ({
	borderColor: theme.palette.success.main,
	color: theme.palette.text.primary,
}));

const CancelledBadge = styled(BaseBadge)(({ theme }) => ({
	borderColor: theme.palette.background.secondary,
	backgroundColor: theme.palette.background.secondary,
	color: theme.palette.text.primary,
}));

export default BookingStateBadge;
